import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=154cad1e&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"
import style0 from "./Card.vue?vue&type=style&index=0&id=154cad1e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154cad1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('154cad1e')) {
      api.createRecord('154cad1e', component.options)
    } else {
      api.reload('154cad1e', component.options)
    }
    module.hot.accept("./Card.vue?vue&type=template&id=154cad1e&scoped=true", function () {
      api.rerender('154cad1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MenuItemSelect/Card.vue"
export default component.exports